import { Reveal, Chapter } from "./shared";

const shifts = [
  { t: "The pitch you time right", b: "The big ask lands on a 74 OPEN day, not a 28 PRESSURED one. Same words, different meeting." },
  { t: "The fight you don't have", b: "Tension shows up in your morning read. The hard talk moves to Thursday. Tuesday stays good." },
  { t: "The recovery you actually take", b: "Your calendar says push. Your code says rest. You listen." },
  { t: "The energy you stop leaking", b: "Reading the room used to be exhausting. Now it's one glance." },
];

export const Transformation = () => (
  <section className="py-16 sm:py-24 lg:py-32 bg-[#F2F0EB] text-[#0B0B0C]" data-testid="transformation-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="08" label="The payoff" />
      </Reveal>
      <Reveal>
        <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95] max-w-4xl mb-10 sm:mb-16" data-testid="transformation-headline">
          What changes when you
          <br />
          <span className="text-[#FF4D0A]">choose better moments.</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0B0B0C]/15 border border-[#0B0B0C]/15 overflow-hidden">
        {shifts.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.1} className="bg-[#F2F0EB] p-6 sm:p-8 lg:p-12 hover:bg-[#ECEAE3] transition-colors duration-500" data-testid={`transformation-item-${i + 1}`}>
            <span className="font-mono-brand text-xs text-[#FF4D0A]">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="font-display font-bold text-2xl mt-4 mb-3">{s.t}</h3>
            <p className="text-[#55585E] leading-relaxed">{s.b}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
